// extracted by mini-css-extract-plugin
export var button = "_ju-0";
export var donut = "_ju-1";
export var donutFill = "_ju-3";
export var donutTrack = "_ju-2";